import { useAuthContext } from './adminAuthHook'
import { getAllBookings } from '../redux/reducers/bookingsSlice'
import { useDispatch } from 'react-redux';

export default function BookingHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { admin } = useAuthContext()
    const getBookings=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/admin/bookings/get`,{
          headers:{
            'Authorization': `Bearer ${admin.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllBookings(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getBookings}
}
